import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import notificationsActions from '../notifications/action-creators';
import tagsCommitTypes from './commit-types';

const tagsActionCreators = {
  addTag() {
    return {
      isAddingTag: true,
      type: tagsCommitTypes.SET_IS_ADDING_TAG,
    };
  },
  closeAddTag() {
    return {
      isAddingTag: false,
      type: tagsCommitTypes.SET_IS_ADDING_TAG,
    };
  },
  closeEditTag() {
    return {
      isEditingTag: null,
      type: tagsCommitTypes.SET_IS_EDITING_TAG,
    };
  },
  createTag(formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('createTag'));
      const data = await ApiService.post('/api/v1/tags', formData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('createTag'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.createTagSuccess(data));
      }
    };
  },
  createTagSuccess(tagResponse) {
    return (dispatch) => {
      dispatch(notificationsActions.addSavedSuccessfully('Tag created'));
      dispatch(this.closeAddTag());
      dispatch(this.pushTag(tagResponse.data));
    };
  },
  editTag(tagGuid) {
    return {
      isEditingTag: tagGuid,
      type: tagsCommitTypes.SET_IS_EDITING_TAG,
    };
  },
  fetchTags() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchTags'));
      const data = await ApiService.get('/api/v1/tags')
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchTags'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchTagsSuccess(data));
      }
    };
  },
  fetchTagsSuccess(tagsResponse) {
    return (dispatch) => {
      dispatch(this.pushTags(tagsResponse.data));
    };
  },
  loadTagsIndex() {
    return (dispatch) => {
      dispatch(this.fetchTags());
    };
  },
  pushTag(tag) {
    return {
      tag,
      type: tagsCommitTypes.PUSH_TAG,
    };
  },
  pushTags(tags) {
    return {
      tags,
      type: tagsCommitTypes.PUSH_TAGS,
    };
  },
  replaceTag(tag) {
    return {
      tag,
      type: tagsCommitTypes.REPLACE_TAG,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: tagsCommitTypes.SET_TAGS_IS_LOADING,
    };
  },
  setSelectedTag(selectedGuid) {
    return {
      selectedGuid,
      type: tagsCommitTypes.SET_SELECTED_TAG_GUID,
    };
  },
  updateTag(formData) {
    return async (dispatch) => {
      const patch = { ...formData };
      // Remove redundant
      delete patch.tagGuid;
      dispatch(this.setIsLoading('updateTag'));
      const data = await ApiService.patch(`/api/v1/tags/${formData.tagGuid}`, patch)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateTag'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.updateTagSuccess(data));
      }
    };
  },
  updateTagSuccess(tagResponse) {
    return (dispatch) => {
      dispatch(notificationsActions.addSavedSuccessfully('Tag updated'));
      dispatch(this.closeEditTag());
      dispatch(this.replaceTag(tagResponse.data));
    };
  },
};

export default tagsActionCreators;
